import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./Pages/Home";
import Navbar from "./Components/Navbar";
import Signup from "./Pages/Signup";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import InterviewRoom from "./Pages/InterviewRoom";
import AuthWrapper from "./Components/authWrapper";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { authenticate } from "./feature/auth/authAPI";

function AppContent() {
  const location = useLocation();
  const hideNavbarRoutes = ["/login", "/signup"];
  const showNavbar = !hideNavbarRoutes.includes(location.pathname);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authenticate())
  }, []);
  return (
    <>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <AuthWrapper>
              {" "}
              <Dashboard />{" "}
            </AuthWrapper>
          }
        />
        <Route
          path="/interview/:roomId"
          element={
            <AuthWrapper>
              <InterviewRoom />
            </AuthWrapper>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
